import { render } from "./DarekPlatform.vue?vue&type=template&id=95704ce4&ts=true"
import script from "./DarekPlatform.vue?vue&type=script&lang=ts"
export * from "./DarekPlatform.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__